var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app","body-scroll-lock":""}},[_c('div',{staticClass:"background animated"}),_c('personalHeader'),_c('navigation',{attrs:{"id":"nav"}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }